var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { Component, Prop, Vue } from 'vue-property-decorator';
// Used when the page gives no style (see views._map_style_url).
var FALLBACK_STYLE = 'https://basemaps.cartocdn.com/gl/voyager-gl-style/style.json';
var LABEL_FONT = ['Open Sans Bold', 'Arial Unicode MS Bold'];
/** Only plain http(s) or site-relative links. */
function safeUrl(url) {
    if (typeof url !== 'string' || !url)
        return '';
    if (url.charAt(0) === '/' && url.charAt(1) !== '/')
        return url;
    return /^https?:\/\//i.test(url) ? url : '';
}
function validCorners(corners) {
    if (!Array.isArray(corners) || corners.length !== 4)
        return null;
    var out = corners.map(function (c) { return [Number(c && c[0]), Number(c && c[1])]; });
    return out.every(function (c) { return isFinite(c[0]) && isFinite(c[1]); }) ? out : null;
}
/**
 * A customer's factory plan, as deep mode's render_map kind="site" built it from the database
 * (deep/maps.py): the factory's floor-plan image at its corners, each supermarket's image and
 * outline, and the racks drawn in them - coloured by a value when the model gave one, else the
 * racks of the analysed table in their own colour and the rest grey. Drawn the way the
 * Factories page (general/customer/site_map/detail.html) draws it; a rack opens a popup that
 * links to the rack.
 */
var SiteMapBlock = /** @class */ (function (_super) {
    __extends(SiteMapBlock, _super);
    function SiteMapBlock() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.error = null;
        _this.map = null;
        _this.observer = null;
        _this.numberFormat = null;
        return _this;
    }
    Object.defineProperty(SiteMapBlock.prototype, "factory", {
        get: function () {
            return (this.payload && this.payload.factory) || {};
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SiteMapBlock.prototype, "factoryName", {
        get: function () {
            return this.factory.customer ? "".concat(this.factory.name, " (").concat(this.factory.customer, ")") : this.factory.name || '';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SiteMapBlock.prototype, "factoryUrl", {
        get: function () {
            return safeUrl(this.factory.url);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SiteMapBlock.prototype, "legend", {
        get: function () {
            return this.payload && this.payload.legend;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SiteMapBlock.prototype, "valueLabel", {
        get: function () {
            return (this.payload && this.payload.value_label) || '';
        },
        enumerable: false,
        configurable: true
    });
    SiteMapBlock.prototype.format = function (value) {
        if (typeof value !== 'number' || !isFinite(value))
            return '';
        if (!this.numberFormat) {
            this.numberFormat = new Intl.NumberFormat(navigator.language || undefined, { maximumFractionDigits: 2 });
        }
        return this.numberFormat.format(value);
    };
    SiteMapBlock.prototype.mounted = function () {
        this.build();
    };
    SiteMapBlock.prototype.beforeDestroy = function () {
        if (this.observer)
            this.observer.disconnect();
        this.observer = null;
        if (this.map) {
            try {
                this.map.remove();
            }
            catch (e) {
                /* already gone */
            }
            this.map = null;
        }
    };
    SiteMapBlock.prototype.build = function () {
        var _this = this;
        var corners = validCorners(this.factory.coordinates);
        if (typeof mapboxgl === 'undefined' || !corners) {
            this.error = this.strings.mapRenderError;
            return;
        }
        this.$nextTick(function () {
            var el = _this.$refs.container;
            if (!el)
                return;
            try {
                _this.draw(el, corners);
            }
            catch (e) {
                console.error('AI chat factory map could not be rendered:', e);
                _this.error = _this.strings.mapRenderError;
            }
        });
    };
    SiteMapBlock.prototype.draw = function (el, corners) {
        var _this = this;
        mapboxgl.accessToken = this.mapConfig.accessToken || 'pk.not_required_for_other_tiles';
        var bounds = new mapboxgl.LngLatBounds();
        corners.forEach(function (c) { return bounds.extend(c); });
        var bearing = Number(this.factory.bearing) || 0;
        var map = new mapboxgl.Map({
            container: el,
            style: this.mapConfig.styleUrl || FALLBACK_STYLE,
            bounds: bounds,
            bearing: bearing,
            pitchWithRotate: false,
        });
        var fit = function () { return map.fitBounds(bounds, { bearing: bearing, padding: 24, duration: 0 }); };
        map.on('error', function (e) { return console.error('AI chat factory map:', e && e.error ? e.error : e); });
        map.addControl(new mapboxgl.NavigationControl(), 'top-right');
        map.on('load', function () {
            map.resize();
            fit();
            _this.addLayers(map, corners);
        });
        var Observer = window.ResizeObserver;
        if (Observer) {
            this.observer = new Observer(function () { return map.resize(); });
            this.observer.observe(el);
        }
        this.map = map;
    };
    SiteMapBlock.prototype.addLayers = function (map, corners) {
        var _this = this;
        var image = safeUrl(this.factory.image);
        if (image) {
            map.addSource('factory', { type: 'image', url: image, coordinates: corners });
            map.addLayer({ id: 'factory', source: 'factory', type: 'raster', paint: { 'raster-opacity': 0.8 } });
        }
        var supermarkets = Array.isArray(this.payload.supermarkets) ? this.payload.supermarkets : [];
        var outlines = [];
        var names = [];
        supermarkets.forEach(function (market, index) {
            var marketCorners = validCorners(market.coordinates);
            if (!marketCorners)
                return;
            var marketImage = safeUrl(market.image);
            if (marketImage) {
                map.addSource("supermarket_".concat(index), { type: 'image', url: marketImage, coordinates: marketCorners });
                map.addLayer({ id: "supermarket_".concat(index), source: "supermarket_".concat(index), type: 'raster', paint: { 'raster-opacity': 1 } });
            }
            outlines.push({ type: 'Feature', geometry: { type: 'Polygon', coordinates: [__spreadArray(__spreadArray([], marketCorners, true), [marketCorners[0]], false)] }, properties: {} });
            if (Array.isArray(market.centre)) {
                names.push({ type: 'Feature', geometry: { type: 'Point', coordinates: market.centre }, properties: { label: String(market.name || '') } });
            }
        });
        map.addSource('supermarkets', { type: 'geojson', data: { type: 'FeatureCollection', features: outlines } });
        map.addLayer({
            id: 'supermarkets', source: 'supermarkets', type: 'line',
            paint: { 'line-color': '#4264fb', 'line-width': 1.5 },
        });
        map.addSource('racks', { type: 'geojson', data: this.payload.racks || { type: 'FeatureCollection', features: [] } });
        map.addLayer({
            id: 'racks', source: 'racks', type: 'fill',
            paint: {
                'fill-color': ['get', 'colour'],
                'fill-opacity': ['case', ['get', 'listed'], 0.85, 0.45],
                'fill-outline-color': '#333',
            },
        });
        map.addSource('rackLabels', { type: 'geojson', data: this.payload.rack_labels || { type: 'FeatureCollection', features: [] } });
        map.addLayer({
            id: 'rackLabels', source: 'rackLabels', type: 'symbol',
            layout: { 'text-field': '{label}', 'text-font': LABEL_FONT, 'text-size': 12 },
            paint: { 'text-color': '#000', 'text-halo-color': '#fff', 'text-halo-width': 1 },
        });
        map.addSource('supermarketLabels', { type: 'geojson', data: { type: 'FeatureCollection', features: names } });
        map.addLayer({
            id: 'supermarketLabels', source: 'supermarketLabels', type: 'symbol',
            layout: { 'text-field': '{label}', 'text-font': LABEL_FONT, 'text-size': 14 },
            paint: { 'text-color': '#1f3fbf', 'text-halo-color': '#fff', 'text-halo-width': 1.2 },
        });
        map.on('mouseenter', 'racks', function () { return (map.getCanvas().style.cursor = 'pointer'); });
        map.on('mouseleave', 'racks', function () { return (map.getCanvas().style.cursor = ''); });
        map.on('click', 'racks', function (e) {
            var feature = e.features && e.features[0];
            if (!feature)
                return;
            new mapboxgl.Popup({}).setLngLat(e.lngLat).setDOMContent(_this.popupContent(feature.properties || {})).addTo(map);
        });
    };
    SiteMapBlock.prototype.popupContent = function (properties) {
        var box = document.createElement('div');
        box.className = 'ai-map-popup';
        var url = safeUrl(properties.url);
        var text = String(properties.label || '#');
        if (url) {
            var link = document.createElement('a');
            link.href = url;
            link.target = '_blank';
            link.rel = 'noopener';
            link.textContent = text;
            box.appendChild(link);
        }
        else {
            box.textContent = text;
        }
        var value = typeof properties.value === 'number' ? this.format(properties.value) : '';
        if (value || this.legend) {
            var line = document.createElement('div');
            line.className = 'ai-map-popup-value';
            line.textContent = "".concat(this.valueLabel ? this.valueLabel + ': ' : '').concat(value || this.strings.mapNoValue);
            box.appendChild(line);
        }
        return box;
    };
    __decorate([
        Prop({ type: Object, required: true })
    ], SiteMapBlock.prototype, "payload", void 0);
    __decorate([
        Prop({ type: Object, default: function () { return ({ styleUrl: '', accessToken: '' }); } })
    ], SiteMapBlock.prototype, "mapConfig", void 0);
    __decorate([
        Prop({ type: Object, required: true })
    ], SiteMapBlock.prototype, "strings", void 0);
    SiteMapBlock = __decorate([
        Component
    ], SiteMapBlock);
    return SiteMapBlock;
}(Vue));
export default SiteMapBlock;
